import { useCallback, useState } from 'react';
import useWebStorage, { PERSISTED_STATE_STORAGE_KEYS } from '@app/component/web-storage/useWebStorage';
import { BiView, shownView, storedView } from './BiView.utilities';

export type { BiView } from './BiView.utilities';
export type BiViewReport = 'SEGMENTATION' | 'CHANNELS';

const KEYS: Record<BiViewReport, PERSISTED_STATE_STORAGE_KEYS> = {
	SEGMENTATION: PERSISTED_STATE_STORAGE_KEYS.BI_SEGMENTATION_VIEW,
	CHANNELS: PERSISTED_STATE_STORAGE_KEYS.BI_CHANNELS_VIEW,
};

// ROO2-295: the View by choice of a BI report with company groups (BiView.utilities). The browser keeps it per report; a
// write that fails (a private window) keeps the choice for this visit only.
const useBiView = (report: BiViewReport, hasGroups: boolean): { view: BiView, setView: (view: BiView) => void } => {
	const storage = useWebStorage();
	const [chosen, setChosen] = useState<BiView>(() => storedView(() => storage.getItem<unknown>(KEYS[report])));
	const setView = useCallback((next: BiView) => {
		setChosen(next);
		try {
			storage.setItem(KEYS[report], next);
		} catch {
			// The choice lives for this visit only when browser storage is unavailable.
		}
	// useWebStorage holds no state: its functions read and write localStorage directly.
	}, [report]);
	return { view: shownView(chosen, hasGroups), setView };
};

export default useBiView;
